import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import $ from 'jquery.facedetection'; 
// import { AlertComponent } from '../components/message/message.component';
import { AlertComponent } from '../dialog/alert/alert.component';
import { LoadingService } from './loading.service';

declare const $: any;

@Injectable({
  providedIn: 'root'
})
export class ImageValidatorService {

  constructor(
    private dialog: MatDialog,
    private loadingService: LoadingService
  ) { }
  faceDetect(src: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const image = new Image();
      this.loadingService.setLoading(true);
      image.onload = () => {
        $(image).faceDetection({
          complete: (faces) => {
            this.loadingService.setLoading(false);
            if (faces.length < 1) {
              this.openErrorDialog("MSG.NO_FACE_DETECT");
              reject("No Face Detected");
            } else if (faces.length == 1){
              const face = faces[0];
              const faceWidth = face.width / image.width;
              if (faceWidth > 0.6) {
                // TOO CLOSE
                this.openErrorDialog("MSG.FACE_TOO_CLOSE");
                reject("Face Too Close");
              } else if (faceWidth < 0.25){
                // TOO FAR
                this.openErrorDialog("MSG.FACE_TOO_FAR");
                reject("Face To Far")
              } else if (Math.abs(image.width - face.width - face.x - face.x) / image.width > 0.15) {
                // NOT CENTER
                this.openErrorDialog("MSG.FACE_NOT_CENTER");
                reject("Face Not Center");
              } else {
                resolve(src);
              }
            } else if (faces.length > 1) {
              this.openErrorDialog("MSG.MANY_FACES_DETECT");
            }
          },
          error: reject
        });
      }
      image.src = src;
    })
  }
  openErrorDialog(message: string /* string localize */): void {
    this.dialog.open(AlertComponent, {
      width: '450px',
      data: {
        isError: true,
        title: 'TITLE.ERROR',
        messages: [message]
      },
      role: 'alertdialog'
    });
  }
}
